import { useEffect, useState } from "react";
import AppBar from "../Header/AppBar";
import ProfileBar from "../ProfileBar/ProfileBar";
import SideBar from "../SideBar/SideBar";
import Profilebox from "../Profilebox/Profilebox";
import { useLocation } from "react-router-dom";
import PrivacyManagement from "../Profile/PrivacyManagement";
import CvCustomization from "../Profile/CvCustomization";
import ReferTalentOrSME from "../Profile/ReferTalentOrSME";
import { useSelector } from "react-redux";
const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const pathCond =
    location.pathname === "/portfolio" ? "lg:w-[50%]" : "lg:w-[77%]";
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  const isTalentApproved =
    basicInfoData?.AdminApproved === "approved" ||
    (!basicInfoData?.AdminApproved && !basicInfoData?.IsTalentApprove);
  console.log("🚀 ~ Layout ~ isTalentApproved:", isTalentApproved);
  // const isTalentApproved =
  //   (basicInfoData?.SmeApproved == "pending" &&
  //     basicInfoData?.AdminApproved == "pending") ||
  //   (basicInfoData?.SmeApproved == "approved" &&
  //     basicInfoData?.AdminApproved == "pending");
  // const isTalentApproved =
  //   (basicInfoData?.AssignSME && basicInfoData?.AdminApproved !== "rejected") ||
  //   (!basicInfoData?.AssignSME && !basicInfoData?.IsTalentApprove);
  const checkScreenSize = () => {
    if (window.innerWidth > 640) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    checkScreenSize(); // Check on mount
    window.addEventListener("resize", checkScreenSize); // Add resize listener
    return () => {
      window.removeEventListener("resize", checkScreenSize); // Remove listener on unmount
    };
  }, []);
  const classes = {
    "/profile": "profileScreen",
    "/communication": "pb-2",
  };
  const RIGHT_SIDEBAR = {
    profile: null,
    portfolio: (
      <div className="space-y-3">
        <PrivacyManagement />
        <CvCustomization />
        <ReferTalentOrSME />
      </div>
    ),
    else: <ProfileBar />,
  };
  const getRightSideBar = (key) => {
    key = key.replace("/", "").trim();
    if (RIGHT_SIDEBAR.hasOwnProperty(key)) return RIGHT_SIDEBAR[key];
    return RIGHT_SIDEBAR["else"];
  };
  return (
    <div className="flex gap-5 md:mt-5 px-3 w-full">
      <div className="w-full md:w-auto">
        <SideBar isOpen={isOpen} closeSidebar={() => setIsOpen(false)} />
      </div>
      <div className="w-full flex flex-col gap-5">
        <div className="flex flex-col md:flex-row gap-x-5 w-full ">
          <div className={`w-[80%] ${isTalentApproved && pathCond}`}>
            {isTalentApproved && <AppBar />}
            <div
              className={`page-height overflow-y-auto ${
                classes[location.pathname]
              }`}
            >
              {children}
            </div>
          </div>
          {isTalentApproved && (
            <div className="w-full md:w-[30%] lg:w-[30%] space-y-3 sm:hidden md:block">
              <Profilebox />
              {getRightSideBar(location.pathname) && (
                <div className="h-screen overflow-auto pb-28">
                  {getRightSideBar(location.pathname)}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Layout;
